import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5cc165fa&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5cc165fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc165fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cc165fa')) {
      api.createRecord('5cc165fa', component.options)
    } else {
      api.reload('5cc165fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5cc165fa&scoped=true", function () {
      api.rerender('5cc165fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system/addcoupon/index.vue"
export default component.exports